// @ts-nocheck



import CommonApi from './../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

const convertDataToServer = (inspectionGtnCost) => ({
  ...inspectionGtnCost,
  cost: convertFromRubToKop(inspectionGtnCost.cost),
  tax: convertFromRubToKop(inspectionGtnCost.tax)
});

const convertDataFromServer = (inspectionGtnCost) => ({
  ...inspectionGtnCost,
  cost: convertFromKopToRub(inspectionGtnCost.cost),
  tax: convertFromKopToRub(inspectionGtnCost.tax)
});

const inspectionGtnCost = new CommonApi(
  'inspectionGtnCost',
  'Стоимость и периодичность ТО Гостехнадзор',
  convertDataToServer,
  convertDataFromServer
);

export default {
  ...inspectionGtnCost
};
